const transfers = {
  transfer: "옮기다", // translated 
  transfers: "이적", // translated 
  dateAndTime: "날짜 및 시간", // translated 
  transferFrom: "다음에서 이체", // translated 
  duration: "지속", // translated 
  numOfPersons: "인원수", // translated 
  baggageAllowance: "수하물 허용량", // translated 
  small: "작은", // translated 
  big: "큰", // translated 
  provider: "공급자", // translated 
  vehicle: "차량", // translated 
  distance: "거리", // translated 
  price: "가격", // translated 
  inboundJourney: "인바운드 여정", // translated 
  outboundJourney: "출발 여정", // translated 
  arrivalTime: "도착 시간", // translated 
  flightDetails: "항공편 상세 정보", // translated 
  inboundPickupDate: "입고 픽업 날짜", // translated 
  outboundPickupDate: "출발 픽업 날짜", // translated 
  travelInfo: "여행 정보", // translated 
  travellersInformation: "여행자 정보", // translated 
  flightsInfo: "항공편 정보", // translated 
  airportYouAreFlyingFrom: "출발 공항", // translated 
  airportYouAreFlyingTo: "도착 공항", // translated 
  inboundFlightNumber: "도착 항공편 번호", // translated 
  outboundFlightNumber: "출발 항공편 번호", // translated 
  inboundAirlineName: "입국 항공사명", // translated 
  outboundAirlineName: "출발 항공사명", // translated 
  tripMode: "여행 모드", // translated 
  airportToPoint: "공항에서 목적지까지", // translated 
  pointToAirport: "공항을 가리키세요", // translated 
  roundTrip: "왕복", // translated 
  destinationPoint: "목적지", // translated 
  originPoint: "출발점", // translated 
  transferType: "전송 유형", // translated 
  min: "민", // translated 
  max: "맥스", // translated 
  pieces: "조각들", // translated 
  cancelationIs: "취소는", // translated 
};


export default transfers;
